import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { apiService } from "../../constants/ApiService";

const TestimonialsSlider = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    responsive: [
      {
        breakpoint: 992,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 576,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  const testimonials = [
    {
      quote: "Smells like something twice the price",
      description:
        "I was skeptical about affordable perfumes, but Valorelle blew me away. Velvet Noir lasts all day, and the bottle looks like a designer brand.",
      name: "Aastha",
      location: "Mumbai",
      image: "../assets/images/inner-page/user/1.jpg",
    },
    {
      quote: "Finally, a fragrance that matches how I feel.",
      description:
        "I chose Serene Whisper because I wanted something soft but confident — and that’s exactly how it made me feel.",
      name: "Priyanshu",
      location: "Bangalore",
      image: "../assets/images/inner-page/user/2.jpg",
    },
    {
      quote: "Bought one, came back for three more.",
      description:
        "I gifted one and kept sniffing it on my friend all day — ended up ordering Moonlit Embrace, Mystique Elegance, and Royal Vanguard for myself!",
      name: "Kavita",
      location: "Delhi",
      image: "../assets/images/inner-page/user/3.jpg",
    },
  ];

    const [clientTable, setClientTable] = useState([]);
  
      const getClientData = async () => {
          try {
              let config = {
                  headers: {
                      'Content-Type': 'application/json', // Important for file upload//s
                      'accept': 'application/json'
                  }
              };
  
              const response = await apiService.get(`/api/ClientMaster/allclient?limit=10`, config)
              if (response.response && response.response.data.errors) {
                  console.log(response.response?.data?.errors)
              }
  
              if (response.status === true) {
                  console.log(response.clientMasterData, "hshshs")
                  setClientTable(response.clientMasterData)
                  // setTotalPage(response.totalPages)
                  // console.log(response.message);
              }
              else {
                  console.log(response.message);
              }
          } catch (error) {
              console.log(error)
              alert('SomeThing went wrong!!');
          }
      };

      
    useEffect(() => {
      getClientData();
  }, []);


  return (
    <section className="review-section section-lg-space" style={{backgroundColor:"transparent"}}>
      <div className="container-fluid">
        <div className="about-us-title text-center">
          <h3 className='inter-font text-white'>Latest Testimonials</h3>
          <h2 className="center text-white">What Our Customers Are Saying</h2>
        </div>
        <div className="row gx-xl-5 gy-xl-0 g-3 ratio_148_1">
          <div className="col-12">
            <Slider {...settings} className="slider-4-half product-wrapper">
              {clientTable.map((item, index) => (
                <div key={index}>
                  <div className="reviewer-box mx-3" style={{border: "1px solid #eaeaea", borderColor: "#c2a57c"}}>
                    <i className="fa-solid fa-quote-right" />
                    <div className="product-rating">
                      <ul className="rating">
                        {[...Array(4)].map((_, i) => (
                          <li key={i}>
                            <i data-feather="star" className="fill" />
                          </li>
                        ))}
                        <li>
                          <i data-feather="star" />
                        </li>
                      </ul>
                    </div>
                    <h3 className="fw-bold inter-font text-theme">"{item.quoted_msg}"</h3>
                    <p>{item.client_feedback}</p>
                    <div className="reviewer-profile">
                      <div className="">
                        <img
                          src={process.env.REACT_APP_API_BASE_URL +item.img_url}
                          className="img-fluid rounded-circle"
                          style={{width: "40px", height: "40px"}} alt="Profile"
                        />
                      </div>
                      <div className="reviewer-name">
                        <h4>{item.client_name}</h4>
                        <h6> - {item.client_location}</h6>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSlider;
